var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-checkbox-group',[_c('van-cell-group',_vm._l((_vm.list),function(item,index){return _c('van-cell',{key:index,attrs:{"clickable":"","title":item.item},on:{"click":function($event){return _vm.toggle(index)}}},[_c('van-checkbox',{ref:"checkboxes",refInFor:true,attrs:{"slot":"right-icon","name":item},slot:"right-icon"})],1)}),1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92f7c276","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/folder.vue
// module id = null
// module chunks = 